/**
 * «Подложка» — the one map switch on the screen, and the only one there will be.
 *
 * It replaced «Подписи», which hid the Esri reference overlays; the Google hybrid tile bakes
 * its place names into the raster, so that switch lost its subject when the basemaps came
 * over from the main product (map/basemap.ts). Two states, both named, `aria-pressed` on
 * each so the state is announced and not merely coloured.
 */

import { T } from "../strings";
import type { BasemapId } from "../map/basemap";

interface Props {
  basemap: BasemapId;
  onChange: (id: BasemapId) => void;
}

const OPTIONS: { id: BasemapId; label: string; icon: string }[] = [
  // A photograph: a frame with a horizon in it.
  {
    id: "hybrid",
    label: T.imagery.basemapHybrid,
    icon: "M3 5 H21 V19 H3 Z M3 15 L9 10 L14 15 M14 13 L17 11 L21 14",
  },
  // A street map: a fold and a road.
  {
    id: "street",
    label: T.imagery.basemapStreet,
    icon: "M9 4 L3 6 V20 L9 18 M9 4 V18 M9 4 L15 6 M15 6 L21 4 V18 L15 20 M15 6 V20 M9 18 L15 20",
  },
];

export function BasemapSwitch({ basemap, onChange }: Props) {
  return (
    <div className="k-basemap" role="group" aria-label={T.imagery.basemapLabel}>
      {OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className="k-iconbtn"
          aria-pressed={basemap === option.id}
          aria-label={option.label}
          title={option.label}
          onClick={() => onChange(option.id)}
        >
          <svg
            viewBox="0 0 24 24"
            width="17"
            height="17"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="square"
            strokeLinejoin="miter"
            aria-hidden="true"
            focusable="false"
          >
            <path d={option.icon} />
          </svg>
        </button>
      ))}
    </div>
  );
}
